module.exports = __webpack_public_path__ + "static/media/withoutstep1.7951e749.png";